module.exports = __webpack_public_path__ + "img/login_icon.897402c6.png";